(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AllergenController', AllergenController);

    AllergenController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Allergen', '$uibModal',
        'ConfirmationService', '$q'];

    function AllergenController(GenericEntityDatatableService, CoreService, Allergen, $uibModal,
                                ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Allergen',
            newButtonTitle: 'New Allergen',
            entityClassHumanized: 'Allergen',
            entityStateName: 'allergen',
            service: Allergen,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('allergen'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('allergen'), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Allergen',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/allergen/update/allergen-dialog.html',
                controller: 'AllergenDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/allergen/update/allergen-dialog.html',
                controller: 'AllergenDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Allergen', function (Allergen) {
                        return Allergen.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Allergen').result.then(function () {
                    Allergen.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
